module.exports = __webpack_public_path__ + "media/images/lb/598-68248242e5fd415d74f10f5142bb7484.svg";